export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-page-doc-7187dd96ee31c36f709aa98524c006d6.svg";